// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListJobHistoryLevelDefinitionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListJobHistoryLevelDefinitionsQuery = { __typename?: 'Query' } & {
  listJobHistoryLevelDefinitions: Array<
    { __typename?: 'JobHistoryLevelDefinitions' } & Pick<Types.JobHistoryLevelDefinitions, 'level' | 'displayName'> & {
        definitions: Array<
          { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'displayName' | 'content'>
        >;
      }
  >;
};

export const ListJobHistoryLevelDefinitionsDocument = /*#__PURE__*/ gql`
    query listJobHistoryLevelDefinitions {
  listJobHistoryLevelDefinitions {
    level
    displayName
    definitions {
      languageCode
      displayName
      content
    }
  }
}
    `;

/**
 * __useListJobHistoryLevelDefinitionsQuery__
 *
 * To run a query within a React component, call `useListJobHistoryLevelDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobHistoryLevelDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobHistoryLevelDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListJobHistoryLevelDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListJobHistoryLevelDefinitionsQuery,
    ListJobHistoryLevelDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobHistoryLevelDefinitionsQuery, ListJobHistoryLevelDefinitionsQueryVariables>(
    ListJobHistoryLevelDefinitionsDocument,
    options,
  );
}
export function useListJobHistoryLevelDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListJobHistoryLevelDefinitionsQuery,
    ListJobHistoryLevelDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobHistoryLevelDefinitionsQuery, ListJobHistoryLevelDefinitionsQueryVariables>(
    ListJobHistoryLevelDefinitionsDocument,
    options,
  );
}
// @ts-expect-error
export function useListJobHistoryLevelDefinitionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListJobHistoryLevelDefinitionsQuery,
    ListJobHistoryLevelDefinitionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListJobHistoryLevelDefinitionsQuery, ListJobHistoryLevelDefinitionsQueryVariables>;
export function useListJobHistoryLevelDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListJobHistoryLevelDefinitionsQuery,
        ListJobHistoryLevelDefinitionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListJobHistoryLevelDefinitionsQuery | undefined,
  ListJobHistoryLevelDefinitionsQueryVariables
>;
export function useListJobHistoryLevelDefinitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListJobHistoryLevelDefinitionsQuery,
        ListJobHistoryLevelDefinitionsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListJobHistoryLevelDefinitionsQuery, ListJobHistoryLevelDefinitionsQueryVariables>(
    ListJobHistoryLevelDefinitionsDocument,
    options,
  );
}
export type ListJobHistoryLevelDefinitionsQueryHookResult = ReturnType<typeof useListJobHistoryLevelDefinitionsQuery>;
export type ListJobHistoryLevelDefinitionsLazyQueryHookResult = ReturnType<
  typeof useListJobHistoryLevelDefinitionsLazyQuery
>;
export type ListJobHistoryLevelDefinitionsSuspenseQueryHookResult = ReturnType<
  typeof useListJobHistoryLevelDefinitionsSuspenseQuery
>;
